document.addEventListener('DOMContentLoaded', function() {
  var toggle = document.querySelector('.bb-mobile-toggle');
  var nav    = document.querySelector('.bb-nav');
  toggle.addEventListener('click', function() {
    nav.classList.toggle('bb-nav--open');
  });
});
// psst… CTA popup
var cta = document.querySelector('.bb-cta-trigger');
var popup;

window.addEventListener('scroll', function() {
  if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
    cta.classList.add('visible');
  } else {
    cta.classList.remove('visible');
  }
});

cta.addEventListener('click', function() {
  if (!popup) {
    popup = document.createElement('div');
    popup.className = 'bb-cta-popup';
    popup.innerHTML = `
      <div class="bb-cta-popup__inner">
        <button class="bb-cta-popup__close">&times;</button>
        <h2>Want to receive notes from A.?</h2>
        <form>
          <input type="email" placeholder="Your email" required>
          <button type="submit">Submit</button>
        </form>
        <p>We’ll never spam—just buttery goodness.</p>
      </div>
    `;
    document.body.appendChild(popup);
    popup.querySelector('.bb-cta-popup__close').addEventListener('click', function() {
      popup.classList.remove('visible');
    });
  }
  popup.classList.add('visible');
});
